<template>
  <span class="mh-nav-icon" :style="{ width: `${size}px`, height: `${size}px` }" aria-hidden="true">
    <img
      class="mh-nav-icon__dia"
      :src="NAV_ICON_WEBP[name]"
      alt=""
      :width="size"
      :height="size"
      decoding="async"
      draggable="false"
    />
    <PepiIcon class="mh-nav-icon__noche" :name="TRAZOS[name]" :size="trazo" :stroke="2" />
  </span>
</template>

<script setup lang="ts">
/* Icono del menú. Los dos están SIEMPRE en el DOM: el de día (recorte acuarela, `<img>`) y
   el de noche (trazo de línea, `<svg>` en `currentColor`). Cuál se ve lo decide el CSS con
   `:root[data-theme='dark']` (base.css): no hay `v-if` sobre el tema, así que cambiar de
   tema no vuelve a pintar el menú (design D10). La etiqueta y el punto del estado activo
   NO son parte del icono: los pone quien lo usa. (El comentario va aquí y no en la
   plantilla: uno al principio de `<template>` haría del componente un fragmento.) */
import { computed } from 'vue'
import PepiIcon from '../icons/PepiIcon.vue'
import type { IconName } from '../icons/icon-paths'
import { NAV_ICON_WEBP, type NavIconName } from '../assets/nav'

const props = withDefaults(defineProps<{ name: NavIconName; size?: number }>(), { size: 40 })

/** El trazo de línea de cada icono (`icon-paths.ts`). */
const TRAZOS: Record<NavIconName, IconName> = {
  inicio: 'navInicio',
  chat: 'navChat',
  agenda: 'navAgenda',
  tareas: 'navTareas',
  familia: 'navFamilia',
  perfil: 'navPerfil',
}

/** El trazo del recorte ocupa el 70 % de su lienzo (build-nav-icons); el de línea, lo mismo. */
const trazo = computed(() => Math.round(props.size * 0.7))
</script>
